"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaModelRegistry = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const AssetMetaModel_1 = __importDefault(require("../metamodels/AssetMetaModel"));
const ConversationMetaModel_1 = __importDefault(require("../metamodels/ConversationMetaModel"));
const IndustryMetaModel_1 = __importDefault(require("../metamodels/IndustryMetaModel"));
const IssueMetaModel_1 = __importDefault(require("../metamodels/IssueMetaModel"));
const IssuesToDoMetaModel_1 = __importDefault(require("../metamodels/IssuesToDoMetaModel"));
const OpDefinitionMetaModel_1 = __importDefault(require("../metamodels/OpDefinitionMetaModel"));
const OpMetaModel_1 = __importDefault(require("../metamodels/OpMetaModel"));
const OpsToDoMetaModel_1 = __importDefault(require("../metamodels/OpsToDoMetaModel"));
const OrganisationMetaModel_1 = __importDefault(require("../metamodels/OrganisationMetaModel"));
const PlaceMetaModel_1 = __importDefault(require("../metamodels/PlaceMetaModel"));
const PositionMetaModel_1 = __importDefault(require("../metamodels/PositionMetaModel"));
const QuestionSetMetaModel_1 = __importDefault(require("../metamodels/QuestionSetMetaModel"));
const StaffMetaModel_1 = __importDefault(require("../metamodels/StaffMetaModel"));
const SuperUserMetaModel_1 = __importDefault(require("../metamodels/SuperUserMetaModel"));
const TaskMetaModel_1 = __importDefault(require("../metamodels/TaskMetaModel"));
const TeamboardMetaModel_1 = __importDefault(require("../metamodels/TeamboardMetaModel"));
const TeamMetaModel_1 = __importDefault(require("../metamodels/TeamMetaModel"));
const TemplateMetaModel_1 = __importDefault(require("../metamodels/TemplateMetaModel"));
const WorkflowMetaModel_1 = __importDefault(require("../metamodels/WorkflowMetaModel"));
const OrgTemplateMetaModel_1 = __importDefault(require("../metamodels/OrgTemplateMetaModel"));
exports.MetaModelRegistry = {
    [DataType_1.default.ASSET]: AssetMetaModel_1.default,
    [DataType_1.default.ISSUE]: IssueMetaModel_1.default,
    [DataType_1.default.CONVERSATION]: ConversationMetaModel_1.default,
    [DataType_1.default.OP]: OpMetaModel_1.default,
    [DataType_1.default.OP_TODO]: OpsToDoMetaModel_1.default,
    [DataType_1.default.ISSUE_TODO]: IssuesToDoMetaModel_1.default,
    [DataType_1.default.OPDEFINITION]: OpDefinitionMetaModel_1.default,
    [DataType_1.default.ORGANISATION]: OrganisationMetaModel_1.default,
    [DataType_1.default.POSITION]: PositionMetaModel_1.default,
    [DataType_1.default.SUPERUSER]: SuperUserMetaModel_1.default,
    [DataType_1.default.STAFF]: StaffMetaModel_1.default,
    [DataType_1.default.PLACE]: PlaceMetaModel_1.default,
    [DataType_1.default.TEAM]: TeamMetaModel_1.default,
    [DataType_1.default.TEAMBOARD]: TeamboardMetaModel_1.default,
    [DataType_1.default.TASK]: TaskMetaModel_1.default,
    [DataType_1.default.TEMPLATE]: TemplateMetaModel_1.default,
    [DataType_1.default.INDUSTRY]: IndustryMetaModel_1.default,
    [DataType_1.default.WORKFLOW]: WorkflowMetaModel_1.default,
    [DataType_1.default.QUESTIONSET]: QuestionSetMetaModel_1.default,
    [DataType_1.default.CONVERSATION]: ConversationMetaModel_1.default,
    [DataType_1.default.ORGTEMPLATE]: OrgTemplateMetaModel_1.default,
};
exports.default = exports.MetaModelRegistry;
